import React from 'react';
import { inject } from 'mobx-react';
import { mergeStyleSets, FontSizes, FontWeights } from '@fluentui/react';

import { getRedirectionUrl } from 'src/api';
import { BRAND_NAVATAR } from 'src/constants';
import MainLogo from '@v2/components/base/MainLogo';
import { useBrandedLogos } from 'src/brands';
import { AccountType } from 'shared/types/flowstep';

const classNames = mergeStyleSets({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    selectors: {
      '& > p': {
        textAlign: 'center',
      },
    },
  },
  title: {
    fontSize: FontSizes.xxLarge,
    fontWeight: FontWeights.light,
  }
})

const About = ({ userStore }) => {
  const { organizationType = '', version = '', brand, accountType } = userStore || {};
  const { mainLogo } = useBrandedLogos();

  return (
    <div className={classNames.root}>
      <MainLogo logo={mainLogo}>

        {brand !== BRAND_NAVATAR &&
          <>
            <div className={classNames.title}>XL-Connector 365</div>
            <p>Copyright 2015-2026 © Xappex</p>
          </>
        }

        {brand === BRAND_NAVATAR &&
          <>
            <div className={classNames.title}>Navatar Excel Connect 365</div>
          </>
        }
      </MainLogo>

      {brand !== BRAND_NAVATAR &&
        <p><a href={getRedirectionUrl({ url: 'https://www.xappex.com' })} target="_blank">www.xappex.com</a> All rights reserved.</p>
      }

      {brand === BRAND_NAVATAR &&
        <p><a href={getRedirectionUrl({ url: 'https://navatargroup.com' })} target="_blank">navatargroup.com</a></p>
      }
      <p>Version: <span>{config.version}</span></p>
      {accountType === AccountType.SF && <>
        <p>Organization Type: {organizationType}</p>
        <p>Salesforce Api version: {version}</p>
        <p>Salesforce™ is the registered trademark of Salesforce.com Inc.</p>
      </>}
    </div>
  )
}

export default inject('userStore')(About);